export const SET_RFP_WRITERS = 'SET_RFP_WRITERS'
export const SET_RFP_ANSWER_PANEL_WIDTH_PCT = 'SET_RFP_ANSWER_PANEL_WIDTH_PCT'
